import React from 'react'
import Service from '../Service'

const ApiIntegration = () => {
    const title = 'API Development & Integration'
    const description = 'Bug Resistance specializes in designing, developing, and integrating RESTful and GraphQL APIs that power modern digital ecosystems. We build secure, well-documented APIs that enable seamless data exchange between your applications, third-party services, and partner systems.'
  return (
    <>
        <Service title={title} description={description} />
    </>
  )
}

export default ApiIntegration
